const REQUEST_INTERVAL_IN_MILLISECONDS = 20000;

export default {
  REQUEST_INTERVAL_IN_MILLISECONDS
};
